import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:record-details',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Single Record Details page',
    name: 'Record Details',
    page: { id: prebuilt.Page.Id.SpaceRecordDetails },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
